import { render, staticRenderFns } from "./logModal.vue?vue&type=template&id=220564c2&scoped=true"
import script from "./logModal.vue?vue&type=script&lang=js"
export * from "./logModal.vue?vue&type=script&lang=js"
import style0 from "./logModal.vue?vue&type=style&index=0&id=220564c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220564c2",
  null
  
)

export default component.exports